import { cookie } from '@gaodun.com/gtools';
import { IReqgetTeamSet } from '@types';
import {http, httpSsm} from './index';

//查询团队列表
export const teamSettingTeamList  = (params:{teamType:number|string}) => http.get('/teaching-workbench/booking/auth/product/team-setting/list',params);

//查询团队配置
export const getTeamSetData  = (params:IReqgetTeamSet) => http.get(`/teaching-workbench/booking/team-setting/${params.teamSettingId}`,{productType:params.productType});
//分页查询团队配置
export const getTeamSetTask  = (params:{ 
    teamSettingId:number|string,                //类型：Number  必有字段  备注：团队主键id
    productType:string,                //类型：String  必有字段  备注：产品码类型 /** * sp或者cp */
    pageNum:number,                //类型：Number  必有字段  备注：页码
    pageSize:number                //类型：Number  必有字段  备注：每页条数
    }) => http.post(`/teaching-workbench/booking/team-product/config`,params);


//保存团队配置表单
export const saveTeamSettingTask  = (params:any) => http.post('/teaching-workbench/booking/team-setting/edit', params);

//保存CP CPB🐴 
// "id":1,                //类型：Number  可有字段  备注：cp产品id
//     "settingId":1,                //类型：Number  必有字段  备注：服务团队id
//     "product":"mock",                //类型：String  必有字段  备注：产品码
//     "bookingNum":1,                //类型：Number  可有字段  备注：CP码对应次数
//     "operator":"mock",                //类型：String  必有字段  备注：操作人
//     "operatorId":1,                //类型：Number  必有字段  备注：操作人ID
//     "isDel":1,                //类型：Number  可有字段  备注：是否删除
//     "cycleType":1,                //类型：Number  可有字段  备注：是否有周期，0没有，大于0有
//     "cycle":1                //类型：Number  可有字段  备注：周期频率
export const editCPTask  = (params: any) => http.post('/teaching-workbench/booking/cp/save-product-number',params);
///booking/cp/save-product-number


export const getLogTask  = (params:{pageSize:number, pageNum:number, serviceTeamId:number}) => http.get(`/teaching-workbench/booking/team/configuration/log/${params.serviceTeamId}`, params);

//保存SP 
export const savePrdNumberTask  = (params:{productNumber?:string, productType:number, serviceSettingId:number|string}) => http.post('/teaching-workbench/booking/save-product-number', params);

export const delPrdTask  = (id:string, type:number) => http.post(`/teaching-workbench/booking/product/service/${id}?type=${type}`);

export const querySpTask = (id: string | number, teamSettingId: string | number) => http.get(`/teaching-workbench/booking/product/${id}?teamSettingId=${teamSettingId}`);

//预检
export const verifyUpdate = (params: {	serviceTeamId:number,subjectList: any [],operatorId : number}) => http.post('/teaching-workbench//booking/teacher/verify/team/subject', params);

//团队-修改团队科目配置
export const updateSujects = (params: {	serviceTeamId:number,subjectList: any [],operatorId : number}) => http.post('/teaching-workbench/booking/teacher/modify/team/subject', params);

//通过团队项目查询可配置科目
export const getConfigurableSubjectsByProject = (serviceTeamId:number) => http.get(`/teaching-workbench/booking/teacher/choose/team/project/subject/${serviceTeamId}`);

//查询团队已配置科目
export const getConfiguredSubjectsByProject = (serviceTeamId:number) => http.get(`/teaching-workbench/booking/teacher/team/project/subject/${serviceTeamId}`);




